/*
 * @Author: edvardchen
 * @Date:   2017-03-08 11:32:15
 * @Last Modified by: qiyuanchen
 * @Last Modified time: 2019-12-04 15:49:34
 */

// @flow
import React from 'react';
import isFeedsFast from '../../../../utility/isFeedsFast';
import { isLoadKuaiBao } from '../../../../utility/PageConfigDataForShare';

import styles from './LabelForShare.scss';

type Props = {
  text: string,
  withBorder?: boolean,
};

export default function MediaLabel({ text, withBorder }: Props) {
  if (withBorder) {
    let btnText = isFeedsFast() ? '打开天天快报极速版阅读' : '打开QQ浏览器阅读';

    // 拉新拉活看点快报
    if (isLoadKuaiBao()) {
      btnText = '打开看点快报阅读';
    }

    return (
      <p className={styles.modNewTag}>
        <span>{btnText}</span>
        <i></i>
      </p>
    );
  }
  return <span className={styles.commentText}>{text}</span>;
}
